import { render, staticRenderFns } from "./AuthorityManagementRule.vue?vue&type=template&id=898e9d32&scoped=true&"
import script from "./AuthorityManagementRule.vue?vue&type=script&lang=js&"
export * from "./AuthorityManagementRule.vue?vue&type=script&lang=js&"
import style0 from "./AuthorityManagementRule.vue?vue&type=style&index=0&id=898e9d32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898e9d32",
  null
  
)

export default component.exports